import { AsyncPipe } from '@angular/common';
import { Component, inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { RidesFacade } from '@uzurv/rideWss/app/pages/rides/rides.facade';
import { setAppInjector } from '@uzurv/rideWss/app/util';
import { Subject } from 'rxjs';
import { AppFacade } from './app.component.facade';
import { FooterComponent } from './components/footer/footer.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [AsyncPipe, RouterOutlet, ToolbarComponent, FooterComponent, MatIconModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  readonly destroyed$ = new Subject<boolean>();

  readonly appFacade: AppFacade = inject(AppFacade);
  readonly ridesFacade: RidesFacade = inject(RidesFacade);

  constructor(private injector: Injector) {
    setAppInjector(this.injector);
  }

  ngOnInit(): void {
    this.appFacade.rehydrateState();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleLogout(): void {
    this.appFacade.logout();
  }
}
